import { render, staticRenderFns } from "./CamsSetting.vue?vue&type=template&id=6aa533dc"
import script from "./CamsSetting.vue?vue&type=script&lang=js"
export * from "./CamsSetting.vue?vue&type=script&lang=js"
import style0 from "./CamsSetting.vue?vue&type=style&index=0&id=6aa533dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports